export const CALENDAR_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const CALENDAR_WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function formatEventTimeShort(date) {
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function eventLooksAllDay(ev) {
  if (!ev) return false;
  if (ev.all_day === true) return true;
  const startIso = ev.occurrence_starts_at || ev.starts_at;
  const endIso = ev.occurrence_ends_at || ev.ends_at;
  if (!startIso || !endIso) return false;
  const hours = (new Date(endIso) - new Date(startIso)) / 3600000;
  return hours >= 23 && hours <= 25;
}

export function eventCalendarYmd(ev) {
  const iso = ev?.occurrence_starts_at || ev?.starts_at || '';
  if (!iso) return '';
  if (eventLooksAllDay(ev)) {
    const t = Date.parse(iso);
    if (Number.isNaN(t)) return String(iso).slice(0, 10);
    return new Date(t + 12 * 3600 * 1000).toISOString().slice(0, 10);
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function eventLocalNoon(ev) {
  const ymd = eventCalendarYmd(ev);
  return ymd ? new Date(`${ymd}T12:00:00`) : new Date(ev?.occurrence_starts_at || ev?.starts_at);
}

export function buildUpcomingItems({ events, momentsByDay, todayYMD, formatYMD, displayStart, limit = 6 }) {
  const items = [];

  Object.entries(momentsByDay || {}).forEach(([day, moments]) => {
    if (day >= todayYMD && moments.length > 0) {
      items.push({
        kind: 'harvest',
        sortKey: day,
        day,
        moments,
      });
    }
  });

  (events || []).forEach((ev) => {
    const start = displayStart(ev);
    const sortKey = formatYMD(start);
    if (sortKey >= todayYMD) {
      items.push({
        kind: 'event',
        sortKey,
        ev,
      });
    }
  });

  return items.sort((a, b) => a.sortKey.localeCompare(b.sortKey)).slice(0, limit);
}
